export class AppEnvironemnt {
    static apiServer: string = "";
    static imageServer: string = "";
    static version: string;
}